import { createUseStyles } from 'react-jss'
import { trafficGreenDark, darkGrey, lightGrey, trafficRedDark } from '../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  checkboxBlock: {
    marginTop: 16
  },
  testButton: {
    marginTop: 10,
    width: '100%'
  },
  messageBlock: {
    background: 'white',
    borderColor: lightGrey
  },
  successMessageRow: {
    display: 'block'
  },
  successMessageValue: {
    color: darkGrey
  },
  successMessageGreenValue: {
    color: trafficGreenDark
  },
  successMessageRedValue: {
    color: trafficRedDark
  }
})

export default useStyles
